import giftIcon from "@assets/icon-gift.svg";
import Button from "@components/Button/Button";
import { GiftAnArticleButtonProps } from "@features/giftAnArticle/utils/types";
import { cn } from "@util/helpers";

export default function GiftAnArticleButtonDefault({
  handleClick,
}: GiftAnArticleButtonProps): React.ReactElement {
  return (
    <Button
      onClick={handleClick}
      className={cn("h-10 w-10 outline-none hover:opacity-70")}
      aria-label="Gift this subscriber-only story to your friends and family"
    >
      <img
        className="h-full w-full"
        src={giftIcon}
        width={42}
        height={42}
        alt="Share this article."
      />
    </Button>
  );
}
